import { merchantGuids } from '../../guids';

export const mockMerchantV2Put = (_body, _params, _options) => ({
  merchantGuid: merchantGuids.merchant01
});

export default mockMerchantV2Put;
